import React from 'react';
import { useHistory } from 'react-router-dom';
import { useIonRouter } from '@ionic/react';
import { haptic } from '../utils/haptics';
import Icon from './Icon';

// Shared mobile header for every redesigned feature page.
// Back button (left) + title (centre) + optional right action.
// Matches the .m-header pattern from every prototype.
interface Props {
  title: string;
  onBack?: () => void;
  rightIcon?: string;
  rightLabel?: string;
  onRight?: () => void;
}

const FeatureMobileHeader: React.FC<Props> = ({ title, onBack, rightIcon, rightLabel, onRight }) => {
  const history = useHistory();
  const ionRouter = useIonRouter();
  const handleBack = () => {
    void haptic('light');
    if (onBack) return onBack();
    if (ionRouter.canGoBack()) { history.goBack(); return; }
    history.replace('/app/home');
  };
  return (
    <header className="fhv2-mhead">
      <button className="fhv2-mhead-btn fhv2-unset" onClick={handleBack} aria-label="Back">
        <Icon name="arrow_back" size={18} color="rgba(255,255,255,0.8)" />
      </button>
      <div className="fhv2-mhead-title">{title}</div>
      {rightIcon ? (
        <button className="fhv2-mhead-btn fhv2-unset" onClick={() => { void haptic('light'); onRight?.(); }} aria-label={rightLabel || 'Action'}>
          <Icon name={rightIcon} size={18} color="rgba(255,255,255,0.8)" />
        </button>
      ) : (
        <span className="fhv2-mhead-btn" style={{ opacity: 0, pointerEvents: 'none' }} />
      )}
    </header>
  );
};

export default FeatureMobileHeader;
